import { type } from '@testing-library/user-event/dist/type/index.js';

export const config = {

    context: {
        defaultPath: '/quadapp/weather',
        // tz:'Asia/Kolkata',
        tz: 'UTC',
    },
    controls: {
        combobox: true,
        layers: true,
        widgets: true,
    },
    combobox: {
        //combolist.js path:'/home/user/template-proj/src/config/comboList.js',
        default: 'MAURITIUS',
        highlightLayer: true,
        layerParams: {
            wmsURL: 
            '/geoserver_2/worldview/wms',
            // '/qg/worldview/wms',
            wmsParams: {
                // layers: 'worldview:Dynamic_India',
                layers: 'worldview:SAARC',
                transparent: true,
                format: 'image/png',
            }
        }
    },
    contours:{
        contours:false,
    },
    interactions: {
        variant: 'outline-success',
    },
    about: {
        heading: '',
        subheading: 'Information Services',
    },
    map: {
        center: [22.00, 79.00],//For Sir Creek
        // zoom:10,
        zoom: 6,
        // center:[19.7, 56.6],//For Oman
        // zoom:4,
        // maxZoom:8,
        maxZoom: 12,

    },
    chartWrappers: {
        forecast: '10rem',
        // sla:'10rem',
        sla: '12rem',
    },
    widgetList: [
        // { 'id': 0, 'name': 'CyclonePDF', 'value': 'Cyclone', 'displayname': 'Cyclone', 'iconclassname': "icon-widgets-button fad fa-sun-cloud fa-lg ", 'Component': 'Cyclone/CycloneWidget', 'default': false },
        
        { 'id': 1, 'name': 'Satellite', 'value': 'Satellite', 'displayname': 'Satellite Data', 'iconclassname': "icon-widgets-button fad fa-satellite fa-lg ", 'Component': 'Satellite/SATWidget', 'default': true,},
        { 'id': 2, 'name': 'SLA', 'value': 'SLA', 'displayname': 'Sea Level Anomaly', 'iconclassname': "icon-widgets-button fad fa-water fa-lg ", 'Component': 'SLA/SLAWidget', 'default': false },
        { 'id': 3, 'name': 'SWH', 'value': 'SWH', 'displayname': 'Significant Wave Height', 'iconclassname': "icon-widgets-button fad fa-wave-sine fa-lg ", 'Component': 'SWH/SWHWidget', 'default': false },
        { 'id': 4, 'name': 'Nowcast_Rain', 'value': 'Nowcast_Rain', 'displayname': 'Nowcast', 'iconclassname': "icon-widgets-button fad fa-cloud-snow fa-lg ", 'Component': 'Forecast/FWidget', 'default': false},
        { 'id': 5, 'name': 'WF', 'value': 'WF', 'displayname': 'Forecast', 'iconclassname': "icon-widgets-button fad fa-wind fa-lg ", 'Component': 'WeatherForecast/WRFWidget', 'default': false },
        { 'id': 6, 'name': 'WMS', 'value': 'WMS', 'displayname': 'Climate Projection', 'iconclassname': "icon-widgets-button fad fa-sun-cloud fa-lg ", 'Component': 'CMIP/CMIPWidget', 'default': false },
        { 'id': 7, 'name': 'WQ', 'value': 'WQ', 'displayname': 'Water Quality', 'iconclassname': "icon-widgets-button fad fa-hand-holding-water fa-lg ", 'Component': 'WaterQuality/WQWidget', 'default': false },
        { 'id': 8, 'name': 'W', 'value': 'W', 'displayname': 'Winds', 'iconclassname': "icon-widgets-button fad fa-wind fa-lg ", 'Component': 'Winds/WindWidget', 'default': false },
    ],
    applications: [
        {'pattern':'quadapp' ,widgets:[1] ,layers:['']},
        {'pattern':'weather',widgets:[1,2,3,8] ,layers:['DEM'],default:2},
        {'pattern':'rain' ,widgets:[1,4,5,6] ,layers:[''],default:4},
        {'pattern':'waterquality' ,widgets:[1,7,8] ,layers:[''],default:7},
    ],
    
    
}